import React from 'react'

import { useMediaQuery } from '~/services/useMediaQuery'

interface SinglePodcastModuleProps {
  url: string
}

const SinglePodcastModule = ({ url }: SinglePodcastModuleProps) => {
  const isMobile = useMediaQuery(`(max-width: 768px)`)
  const getSpotifyEmbedUrl = (url: string) => {
    const regex =
      /(?:https:\/\/open\.spotify\.com\/(episode|track|show)\/)([a-zA-Z0-9]+)(?:\?.*)?/
    const match = url.match(regex)
    if (match && match[1] && match[2]) {
      return `https://open.spotify.com/embed/${match[1]}/${match[2]}/video?utm_source=generator&theme=0`
    }
    return null
  }

  const embedUrl = getSpotifyEmbedUrl(url)

  if (!embedUrl) {
    return <p>Invalid Spotify URL. Please provide a valid URL.</p>
  }

  return (
    <iframe
      style={{
        borderRadius: '12px',
        width: '100%',
        height: !isMobile ? '400px' : '240px',
      }}
      src={embedUrl}
      width="624"
      height="351"
      frameBorder="0"
      allowFullScreen
      allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
      loading="lazy"
    ></iframe>
  )
}

export default SinglePodcastModule
